export default __webpack_public_path__ + "static/media/host_naviMemo_active.e6884b92.svg";